import React from 'react';
import Button from '../../../forms/Button';

const EditorButtons = ({ editing, onStart, onCancel, onDone, readOnly }) => (
    <div className="ckp-contracts-editor-header-buttons u-margin-left-1">
        <React.Fragment>
            {readOnly ? null : !editing ? (
                <Button className="ckp-contracts-editor-button" label="Edit" onClick={onStart} />
            ) : (
                <React.Fragment>
                    <a onClick={onCancel} className="ckp-buttons-text is-warning">
                        Cancel
                    </a>
                    <Button className="ckp-contracts-editor-button" label="Done" onClick={onDone} />
                </React.Fragment>
            )}
        </React.Fragment>
    </div>
);

export default EditorButtons;
